import React, { useEffect, useRef, useState } from 'react';
import Overlay from './components/common/Overlay';
import { EmptyProductData, ProductData, ProductMetaData, TransitionalVideo } from './interfaces/components';
import Instructions from './pages/Instructions';
import TransitionVideo from './pages/TransitionVideo';
import ExampleTransitionVideo from './assets/videos/Intro.mp4';
import PDP from './pages/PDP';
import { dispatchAudioAnalytics, dispatchStartTagManagerAnalytics, dispatchCTAClickObject } from './Analytics';
import AudioToggleModal from './pages/AudioToggleModal';
import backgroundAudio from './assets/audios/background.mp3';
import Welcome from './pages/Welcome';
import SleepingBeauty from './pages/SleepingBeauty';
import QualitySleep from './pages/QualitySleep';
import Spinner from './components/common/Spinner';
import axios from 'axios';
import OutOfStock from './pages/OutOfStock';
import { getBrowserName, getOpSys } from './utils/helper';
import RestfulEnvironment from './pages/RestfulEnvironment';
import HydratingSkin from './pages/HydratingSkin';
import YourBody from './pages/YourBody';
import RamadanSpirit from './pages/RamadanSpirit';
import Illustration from './pages/Illustration';
import StartingRoom from './pages/StartingRoom';
import SpreadJoy from './pages/SpreadJoy';
import Quiz from './pages/Quiz';
import Toast from './components/common/Toast';

function App() {
  //Refs
  const audioRef = useRef<HTMLAudioElement>(null);

  //States
  const [activeLocale, setActiveLocale] = useState('');
  const [activeScene, setActiveScene] = useState('ramadan_0');
  const [audioActive, setAudioActive] = useState(false);
  const [audioModal, setAudioModal] = useState(false);
  const [tabVisible, setTabVisible] = useState<boolean>(true);
  const [welcomeActive, setWelcomeActive] = useState(true);
  const [instructionsActive, setInstructionsActive] = useState(false);
  const [restfulEnvironmentActive, setRestfulEnvironmentActive] = useState(false);
  const [sleepingBeautyActive, setSleepingBeautyActive] = useState(false);
  const [hydratingSkinActive, setHydratingSkinActive] = useState(false);
  const [qualitySleepActive, setQualitySleepActive] = useState(false);
  const [yourBodyActive, setYourBodyActive] = useState(false);
  const [ramadanSpiritActive, setRamadanSpiritActive] = useState(false);
  const [illustrationActive, setIllustrationActive] = useState(false);
  const [roomStarterActive, setRoomStarterActive] = useState(false);
  const [spreadJoyActive, setSpreadJoyActive] = useState(false);
  const [quizActive, setQuizActive] = useState(false);

  const [toastActive, setToastActive] = useState({ active: false, text: '' });

  const [oosActive, setOosActive] = useState(false);
  const [pdpLoading, setPdpLoading] = useState(false);
  const [pdpActive, setPDPActive] = useState(false);
  const [pdpData, setPDPData] = useState<ProductData>();
  const [productMetaData, setProductMetaData] = useState<ProductMetaData>();

  const [transitionVideo, setTransitionVideo] = useState<TransitionalVideo>({
    videoURL: ExampleTransitionVideo,
    active: false,
    gotoRoom: 'room-1',
  });

  useEffect(() => {
    // window.locale = 'ar-ae';
    const locale = window.locale;
    if (locale === 'ar-ae' || locale === 'ar-sa' || locale === 'ar-kw' || locale === 'ar-qa') {
      setActiveLocale('ar');
    } else if (locale === 'en-ae' || locale === 'en-sa' || locale === 'en-kw' || locale === 'en-qa') {
      setActiveLocale('en');
    }
  }, []);

  const playTransitionVideo = (videoName: string, room: string) => {
    const videoURLs = {
      videoOne: ExampleTransitionVideo,
      videoTwo: ExampleTransitionVideo,
      videoThree: ExampleTransitionVideo,
    };

    setTransitionVideo({
      active: true,
      videoURL: videoURLs[videoName as keyof typeof videoURLs],
      gotoRoom: room,
    });
  };

  const setProductMetaDetails = (roomName: string) => {
    const orgIdMetaTag = document.querySelector('meta[name=org_id]');
    const experienceNameMetaTag = document.querySelector('meta[name=experience_name]');
    let organisationName: string | null = '';
    let experienceName: string | null = '';
    if (orgIdMetaTag) {
      organisationName = orgIdMetaTag.getAttribute('content');
    }
    if (experienceNameMetaTag) {
      experienceName = experienceNameMetaTag.getAttribute('content');
    }
    setProductMetaData({
      organisationName: organisationName,
      experienceName: experienceName,
      roomName: roomName,
      browser: getBrowserName(),
      os: getOpSys(),
    });
  };

  const openProductPopUp = (productId: string, collection: string, scene: string) => {
    dispatchCTAClickObject('loccitane', 'button', 'productOpen', productId, '');
    console.log('Product', productId, collection);
    const roomName: string = scene.split('_')[0];
    setProductMetaDetails(roomName);
    let apiLocale = '';

    if (window.locale === 'ar-ae') {
      apiLocale = 'ar-ae';
    } else if (window.locale === 'ar-sa') {
      apiLocale = 'ar-sa';
    } else if (window.locale === 'en-sa') {
      apiLocale = 'en-sa';
    } else if (window.locale === 'en-kw') {
      apiLocale = 'en-kw';
    } else if (window.locale === 'ar-kw') {
      apiLocale = 'ar-kw';
    } else if (window.locale === 'en-qa') {
      apiLocale = 'en-qa';
    } else if (window.locale === 'ar-qa') {
      apiLocale = 'ar-qa';
    } else {
      apiLocale = 'en-ae';
    }

    if (productId !== null) {
      setPdpLoading(true);
      axios
        .get(process.env.REACT_APP_API_URL + `${apiLocale}/` + productId, {
          params: {
            'include-data': false,
          },
        })
        .then((res) => {
          console.log(res);

          const data = res.data.data as ProductData;

          if (
            window.locale === 'ar-ae' ||
            window.locale === 'ar-sa' ||
            window.locale === 'ar-qa' ||
            window.locale === 'ar-kw'
          ) {
            setPDPData({ ...data, collection: 'لوكسيتان' });
          } else {
            setPDPData({ ...data, collection: "L'Occitane" });
          }
        })
        .catch((err: unknown) => {
          console.log(err);
          setPdpLoading(false);
          setOosActive(true);
        });
    } else {
      setOosActive(true);
    }
  };

  useEffect(() => {
    if (pdpData && pdpData.title !== '') {
      setPdpLoading(false);
      setPDPActive(true);
    }
  }, [pdpData]);

  const openYourBody = () => {
    dispatchCTAClickObject('loccitane', 'button', 'listenToYourBody', 'open', '');
    setYourBodyActive(true);
  };

  const openRamadanSpirit = () => {
    dispatchCTAClickObject('loccitane', 'button', 'ramadanSpirit', 'open', '');
    setRamadanSpiritActive(true);
  };

  const openIllustration = () => {
    dispatchCTAClickObject('loccitane', 'button', 'illustrationBayan', 'open', '');
    setIllustrationActive(true);
  };

  const openRoomStarter = () => {
    setRoomStarterActive(true);
  };

  const openRestfulEnvironment = () => {
    dispatchCTAClickObject('loccitane', 'button', 'restfulEnvironment', 'open', '');
    setRestfulEnvironmentActive(true);
  };

  const openSpreadJoy = () => {
    dispatchCTAClickObject('loccitane', 'button', 'spreadJoy', 'open', '');
    setSpreadJoyActive(true);
  };

  const openSleepingBeauty = () => {
    dispatchCTAClickObject('loccitane', 'button', 'sleepingBeauty', 'open', '');
    setSleepingBeautyActive(true);
  };

  const openHydratingSkin = () => {
    dispatchCTAClickObject('loccitane', 'button', 'hydratingSkin', 'open', '');
    setHydratingSkinActive(true);
  };

  const openQualitySleep = () => {
    dispatchCTAClickObject('loccitane', 'button', 'qualitySleep', 'open', '');
    setQualitySleepActive(true);
  };

  const openQuiz = () => {
    dispatchCTAClickObject('loccitane', 'button', 'quiz', 'open', '');
    setQuizActive(true);
  };

  const updateActiveScene = (sceneName: string) => {
    setActiveScene(sceneName);
  };

  useEffect(() => {
    window.openYourBody = openYourBody;
    window.openRamadanSpirit = openRamadanSpirit;
    window.openIllustration = openIllustration;
    window.openRoomStarter = openRoomStarter;
    window.openSpreadJoy = openSpreadJoy;
    window.openQualitySleep = openQualitySleep;
    window.openHydratingSkin = openHydratingSkin;
    window.openSleepingBeauty = openSleepingBeauty;
    window.openRestfulEnvironment = openRestfulEnvironment;
    window.openProductPopUp = openProductPopUp;
    window.playTransitionVideo = playTransitionVideo;
    window.updateScene = updateActiveScene;
    window.openQuiz = openQuiz;
  }, []);

  // EventListeners
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') setTabVisible(true);
    else setTabVisible(false);
  });

  useEffect(() => {
    if (audioActive && !tabVisible) {
      if (audioRef.current) {
        dispatchAudioAnalytics(false, 'loccitane');
        audioRef.current.pause();
        setAudioActive(false);
      }
    }
  }, [tabVisible]);

  const toggleAudio = () => {
    if (!audioActive) {
      if (audioRef.current) {
        dispatchAudioAnalytics(true, 'loccitane');
        audioRef.current.play();
        setAudioActive(true);
      }
    } else {
      if (audioRef.current) {
        dispatchAudioAnalytics(false, 'loccitane');
        audioRef.current.pause();
        setAudioActive(false);
      }
    }
  };

  const playInitialAudio = (state: boolean) => {
    if (audioRef.current) audioRef.current.volume = 0.5;

    if (state) {
      if (audioRef.current) {
        audioRef.current.play();
        setAudioActive(true);
      }
    } else {
      if (audioRef.current) {
        audioRef.current.pause();
        setAudioActive(false);
      }
    }
  };

  return (
    <>
      <Toast
        activeLocale={activeLocale}
        position="absolute"
        active={toastActive.active}
        text={toastActive.text}
        setActive={(state: boolean) => setToastActive({ ...toastActive, active: state })}
      />

      <AudioToggleModal
        activeLocale={activeLocale}
        proceedAudio={(state: boolean) => {
          dispatchAudioAnalytics(state, 'loccitane');
          playInitialAudio(state);
          setAudioModal(false);
          setInstructionsActive(true);
        }}
        active={audioModal}
      />
      <audio ref={audioRef} src={backgroundAudio} />

      <Overlay
        audioActive={audioActive}
        toggleAudio={toggleAudio}
        activeLocale={activeLocale}
        closeAllUI={() => {
          setInstructionsActive(false);
        }}
        activeScene={activeScene}
        setActiveScene={setActiveScene}
        toggleInstructions={() => {
          const action = instructionsActive ? 'open' : 'close';
          dispatchCTAClickObject('loccitane', 'button', 'toggleInstructions', action, '');
          setInstructionsActive(!instructionsActive);
        }}
        openSpread={() => setSpreadJoyActive(true)}
        setLocale={(locale) => {
          dispatchCTAClickObject('loccitane', 'button', 'toggleLocale', locale, '');
          setActiveLocale(locale);

          if (locale === 'en') {
            if (window.originalLocale === 'en-ae') {
              window.locale = 'en-ae';
            } else if (window.originalLocale === 'en-sa') {
              window.locale = 'en-sa';
            } else if (window.originalLocale === 'en-kw') {
              window.locale = 'en-kw';
            } else if (window.originalLocale === 'en-qa') {
              window.locale = 'en-qa';
            } else if (window.originalLocale === 'ar-ae') {
              window.locale = 'en-ae';
            } else if (window.originalLocale === 'ar-sa') {
              window.locale = 'en-sa';
            } else if (window.originalLocale === 'ar-kw') {
              window.locale = 'en-kw';
            } else if (window.originalLocale === 'ar-qa') {
              window.locale = 'en-qa';
            }
          } else if (locale === 'ar') {
            console.log('Heere');
            console.log(window.originalLocale);

            if (window.originalLocale === 'en-ae') {
              window.locale = 'ar-ae';
            } else if (window.originalLocale === 'en-sa') {
              window.locale = 'ar-sa';
            } else if (window.originalLocale === 'en-kw') {
              window.locale = 'ar-kw';
            } else if (window.originalLocale === 'en-qa') {
              window.locale = 'ar-qa';
            } else if (window.originalLocale === 'ar-ae') {
              window.locale = 'ar-ae';
            } else if (window.originalLocale === 'ar-sa') {
              window.locale = 'ar-sa';
            } else if (window.originalLocale === 'ar-kw') {
              window.locale = 'ar-kw';
            } else if (window.originalLocale === 'ar-qa') {
              window.locale = 'ar-qa';
            }
          }
        }}
      />

      {pdpLoading ? (
        <Spinner />
      ) : (
        <>
          <OutOfStock
            activeLocale={activeLocale}
            active={oosActive}
            setActive={(state: boolean) => setOosActive(state)}
          />
          <PDP
            activeLocale={activeLocale}
            pdpData={pdpData}
            active={pdpActive}
            productMetaData={productMetaData as ProductMetaData}
            setToastActive={(text: string) => setToastActive({ active: true, text: text })}
            setActive={(state) => {
              setPDPActive(state);
              setTimeout(() => {
                setPDPData(EmptyProductData);
              }, 500);
            }}
          />
        </>
      )}

      <Welcome
        activeLocale={activeLocale}
        active={welcomeActive}
        setActive={() => {
          dispatchStartTagManagerAnalytics('loccitane');
          dispatchCTAClickObject('loccitane', 'button', 'welcome', 'enter', '');
          setRoomStarterActive(true);
        }}
      />
      <StartingRoom
        activeLocale={activeLocale}
        active={roomStarterActive}
        setActive={(scene: string) => {
          setActiveScene(scene);
          setRoomStarterActive(false);
          dispatchCTAClickObject('loccitane', 'button', 'startingSelectedRoom', 'close', '');
          setTimeout(() => {
            setWelcomeActive(false);
            setAudioModal(true);
          }, 500);
        }}
      />
      <Instructions
        activeLocale={activeLocale}
        active={instructionsActive}
        setActive={() => {
          setInstructionsActive(false);
          dispatchCTAClickObject('loccitane', 'button', 'instructions', 'close', '');
        }}
      />
      <RestfulEnvironment
        activeLocale={activeLocale}
        active={restfulEnvironmentActive}
        setActive={() => {
          dispatchCTAClickObject('loccitane', 'button', 'restfulEnvironment', 'close', '');
          setRestfulEnvironmentActive(false);
        }}
        openProduct={(pId: string) => openProductPopUp(pId, 'Loccitane', 'None')}
        pdpLoading={pdpLoading}
      />
      <SleepingBeauty
        activeLocale={activeLocale}
        active={sleepingBeautyActive}
        setActive={() => {
          setSleepingBeautyActive(false);
          dispatchCTAClickObject('loccitane', 'button', 'sleepingBeauty', 'close', '');
        }}
        openProduct={(pId: string) => openProductPopUp(pId, 'Loccitane', 'None')}
        pdpLoading={pdpLoading}
      />
      <HydratingSkin
        activeLocale={activeLocale}
        active={hydratingSkinActive}
        setActive={() => {
          setHydratingSkinActive(false);
          dispatchCTAClickObject('loccitane', 'button', 'hydratingSkin', 'close', '');
        }}
      />
      <QualitySleep
        activeLocale={activeLocale}
        active={qualitySleepActive}
        setActive={() => {
          setQualitySleepActive(false);
          dispatchCTAClickObject('loccitane', 'button', 'qualitySleep', 'close', '');
        }}
        openProduct={(pId: string) => openProductPopUp(pId, 'Loccitane', 'None')}
        pdpLoading={pdpLoading}
      />
      <YourBody
        activeLocale={activeLocale}
        active={yourBodyActive}
        setActive={() => {
          setYourBodyActive(false);
          dispatchCTAClickObject('loccitane', 'button', 'listenToYourBody', 'close', '');
        }}
      />
      <Illustration
        activeLocale={activeLocale}
        active={illustrationActive}
        setActive={() => {
          setIllustrationActive(false);
          dispatchCTAClickObject('loccitane', 'button', 'illustrationBayan', 'close', '');
        }}
      />
      <RamadanSpirit
        activeLocale={activeLocale}
        active={ramadanSpiritActive}
        setActive={() => {
          setRamadanSpiritActive(false);
          dispatchCTAClickObject('loccitane', 'button', 'ramadanSpirit', 'close', '');
        }}
      />
      <SpreadJoy
        activeLocale={activeLocale}
        active={spreadJoyActive}
        setActive={() => {
          setSpreadJoyActive(false);
          dispatchCTAClickObject('loccitane', 'button', 'spreadJoy', 'close', '');
        }}
      />
      <Quiz
        activeLocale={activeLocale}
        active={quizActive}
        setActive={() => {
          setQuizActive(false);
          dispatchCTAClickObject('loccitane', 'button', 'Quiz', 'close', '');
        }}
        setToastActive={(text: string) => setToastActive({ active: true, text: text })}
        openProduct={(pId: string) => {
          console.log(pId);
          openProductPopUp(pId, 'Loccitane', 'None');
        }}
      />
      <TransitionVideo
        room={transitionVideo.gotoRoom}
        videoURL={transitionVideo.videoURL}
        playing={transitionVideo.active}
        setPlaying={() => {
          setTransitionVideo({ ...transitionVideo, active: false });
        }}
      />
    </>
  );
}

export default App;
